export const Status = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
export const RequestType = ['01', '02', '04', '05'];
export const SharepointDomain = 'https://cmhcschl.sharepoint.com/sites/HomeownerPortfolio';
export const PrefixFieldFolder = encodeURIComponent('EPIP Pools DEV');
export const Success = 'Successful';
export const UnSuccess = 'Unsuccessful';
export enum PortfolioStatus {
  'Received' = '01',
  'Validation in progress' = '02',
  'Validation completed' = '03',
  'Ready for Credit Bureau' = '04',
  'File ready for Credit Bureau' = '05',
  'Sent to Credit Bureau' = '06',
  'Received from Credit Bureau' = '07',
  'Sent to Master Pool Inventory' = '08',
  'Deleted' = '09',
  'Manual' = '10',
  'Ready to cancel' = '11',
  'Cancellation completed' = '12'
}
